import { render, staticRenderFns } from "./box_1.vue?vue&type=template&id=5d2b668e&scoped=true&"
import script from "./box_1.vue?vue&type=script&lang=js&"
export * from "./box_1.vue?vue&type=script&lang=js&"
import style0 from "./box_1.vue?vue&type=style&index=0&id=5d2b668e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b668e",
  null
  
)

export default component.exports